import ServicioPagoReserva from "../pagos/servicioPagoReserva";
// funciones:
import { hmEnZona, formatearFechaCalendario, formatearFechaHora } from "../../funcionesDatos/fechas";

function ResumenReserva(reservaArg, servicioArg) {
  const reserva = reservaArg?.reserva ?? reservaArg;
  const servicio = reservaArg?.servicio ?? servicioArg;

  const tipoServicio        = servicio?.tipoServicio || servicio?.tipo || "NA";
  const nombreServicio      = servicio?.nombre || servicio?.titulo || "Servicio";
  const descripcionServicio = servicio?.descripcion || servicio?.descripcionCorta || "";
  const imagenServicio      = servicio?.imagenes?.[0]?.preview || servicio?.imagenes?.[0] || servicio?.imagen || servicio?.imagenPrincipal || null;
  const tipoPresencialRaw   = servicio?.tipoDesplazamiento || servicio?.modalidadPresencial || "NA";
  const tipoPresencial      = tipoPresencialRaw === "EnLocal"
    ? "En Local"
    : tipoPresencialRaw === "Domicilio"
      ? "A domicilio"
      : tipoPresencialRaw;
  const pais   = servicio?.pais || servicio?.ubicacion?.pais || "NA";
  const ciudad = servicio?.ciudad || servicio?.ubicacion?.ciudad || "NA";
  const zona   = servicio?.zona || servicio?.ubicacion?.zona || "NA";

  const zonaHorariaReserva = servicio?.zonaHoraria || "America/Bogota";

  const subzonas = Array.isArray(servicio?.subzonas)
    ? servicio.subzonas.filter(Boolean)
    : Array.isArray(servicio?.ubicacion?.subzonas)
      ? servicio.ubicacion.subzonas.filter(Boolean)
      : [];

  const subzonaTexto = subzonas.length > 0
    ? subzonas.join(", ")
    : (servicio?.subzona || servicio?.ubicacion?.subzona || "NA");

  const normalizarTexto = (txt = "") =>
    String(txt)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();

  const descripcionServicioExtracto = (() => {
    const limpio = String(descripcionServicio || "").trim();
    if (!limpio) return "";
    if (limpio.length <= 180) return limpio;
    return `${limpio.slice(0, 177).trim()}...`;
  })();

  const paqueteSeleccionado = Array.isArray(servicio?.paquetes)
    ? servicio.paquetes.find((p) => normalizarTexto(p?.tipo) === normalizarTexto(reserva?.tipoPaquete))
    : null;

  const paqueteExtracto = (() => {
    const descripcionPaquete = String(paqueteSeleccionado?.descripcion || "").trim();
    if (descripcionPaquete) {
      return descripcionPaquete.length <= 140
        ? descripcionPaquete
        : `${descripcionPaquete.slice(0, 137).trim()}...`;
    }

    const detalles = Array.isArray(paqueteSeleccionado?.detalles)
      ? paqueteSeleccionado.detalles.filter(Boolean)
      : [];

    if (detalles.length > 0) {
      const resumen = detalles.slice(0, 2).join(" • ");
      return resumen.length <= 140 ? resumen : `${resumen.slice(0, 137).trim()}...`;
    }

    return "";
  })();


  const obtenerFechaTexto = () => {
    if (!reserva) return "NA";

    if (reserva?.unidadEntrega !== "Horas") {
      const ini = formatearFechaHora(reserva?.inicio || reserva?.fecha, zonaHorariaReserva);
      const fin = formatearFechaHora(reserva?.fin || reserva?.fecha, zonaHorariaReserva);
      if (ini && fin && ini !== fin) return `${ini} → ${fin}`;
      if (ini) return ini;
      return "NA";
    }

    return formatearFechaCalendario(reserva?.fecha, zonaHorariaReserva) || "NA";
  };

  const obtenerAgendaTexto = () => {
    if (!reserva) return "NA";
    return reserva?.unidadEntrega === "Horas"
      ? (reserva?.modoAgenda === "flexible" ? "Flexible" : "Exacta")
      : (reserva?.unidadEntrega || "NA");
  };

  const obtenerHoraFranjaTexto = () => {
    if (!reserva || reserva?.unidadEntrega !== "Horas") return "NA";

    if (reserva?.modoAgenda === "flexible") {
      if (reserva?.franja && reserva?.franja !== "NA") {
        const fr = `${String(reserva.franja).charAt(0).toUpperCase()}${String(reserva.franja).slice(1)}`;
        const hs = (reserva?.horaSolicitada && reserva?.horaSolicitada !== "NA") ? ` • ${reserva.horaSolicitada}` : "";
        return `${fr}${hs}`;
      }
      return (reserva?.horaSolicitada && reserva?.horaSolicitada !== "NA") ? reserva.horaSolicitada : "NA";
    }

    const hIni = hmEnZona(reserva?.inicio, zonaHorariaReserva);
    const hFin = hmEnZona(reserva?.fin, zonaHorariaReserva);

    if (hIni && hFin && hIni !== hFin) return `${hIni} → ${hFin}`;
    if (hIni) return hIni;
    if (reserva?.horaConfirmada && reserva.horaConfirmada !== "NA") return reserva.horaConfirmada;
    if (reserva?.horarioExacto && reserva.horarioExacto !== "NA") return reserva.horarioExacto;

    return "NA";
  };

  return (
    <div className="card shadow-sm border-0" style={{ borderRadius: 18, overflow: "hidden" }} >
      <div style={{ height: 6, background: "linear-gradient(90deg, var(--azul-logo-claro), var(--naranja-cta))", }} />

      <div className="card-body p-3 p-md-4">
        {/* TITULO E ICONO */}
        <div className="d-flex align-items-center gap-2 mb-3">
            {/* ICONO */}
            <div className="d-flex align-items-center justify-content-center rounded-circle" style={{ width: 42, height: 42, background: "rgba(var(--azul-logo-claro-rgb), 0.10)", color: "var(--azul-logo-claro)", flexShrink: 0, }} >
                <i className="bi bi-calendar-check" style={{ fontSize: 18 }}></i>
            </div>
            {/* TITULO */}
            <div>
                <h2 className="h5 fw-bold mb-0">Resumen de la reserva</h2>
                <div className="text-body-secondary" style={{ fontSize: 13 }}>
                Revisa los datos principales antes de continuar.
                </div>
            </div>
        </div>

        {!reserva ? (
          <div className="border rounded-4 p-3 bg-light text-body-secondary" style={{ fontSize: 14 }} >
            No encontramos una reserva activa. Vuelve al carrito para continuar.
          </div>
        ) : (
          <>
            <div className="border rounded-4 p-3 p-md-4" style={{ background: "linear-gradient(180deg, var(--color-bg-surface) 0%, var(--color-bg-surface-alt) 100%)", borderColor: "var(--color-border)", }} >
                {/* PAQUETE, FECHA, AGENDA Y HORA */}
                <div className="row g-3">
                    {/* PAQUETE */}
                    <div className="col-12 col-md-6 col-lg-3">
                    <div className="text-body-secondary mb-1" style={{ fontSize: 12, letterSpacing: 0.3, textTransform: "uppercase" }}>
                        Paquete
                    </div>
                    <div className="fw-semibold" style={{ fontSize: 18, color: "var(--color-text-primary)" }}>
                        {reserva?.tipoPaquete || "NA"}
                    </div>
                    </div>
                    {/* FECHA */}
                    <div className="col-12 col-md-6 col-lg-3">
                    <div className="text-body-secondary mb-1" style={{ fontSize: 12, letterSpacing: 0.3, textTransform: "uppercase" }}>
                        Fecha
                    </div>
                    <div className="fw-semibold" style={{ fontSize: 18, color: "var(--color-text-primary)" }}>
                        {obtenerFechaTexto()}
                    </div>
                    </div>
                    {/* AGENDA */}
                    <div className="col-12 col-md-6 col-lg-3">
                    <div className="text-body-secondary mb-1" style={{ fontSize: 12, letterSpacing: 0.3, textTransform: "uppercase" }}>
                        Agenda
                    </div>
                    <div className="fw-semibold" style={{ fontSize: 18, color: "var(--color-text-primary)" }}>
                        {obtenerAgendaTexto()}
                    </div>
                    </div>

                    
                    {reserva?.unidadEntrega === "Horas" ? (
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="text-body-secondary mb-1" style={{ fontSize: 12, letterSpacing: 0.3, textTransform: "uppercase" }}>
                        Hora / Franja
                        </div>
                        <div className="fw-semibold" style={{ fontSize: 18, color: "var(--color-text-primary)" }}>
                        {obtenerHoraFranjaTexto()}
                        </div>
                        
                        {/* URGENTE */}
                        {reserva?.cobro?.esUrgente === true || reserva?.cobro?.esurgente === true ? (
                        <div className="d-inline-flex align-items-center gap-2 mt-2" style={{ background: "rgba(var(--naranja-cta-rgb), 0.10)", border: "1px solid rgba(var(--naranja-cta-rgb), 0.55)", color: "var(--naranja-oscuro-texto)", borderRadius: 12, padding: "6px 10px", fontSize: 13, fontWeight: 600, }} >
                            <i className="bi bi-lightning-charge-fill"></i>
                            Urgente
                        </div>
                        ) : null}
                    </div>
                    ) : null}
                </div>
            

                {/* ZONA DOMICILIO (si aplica) */}
                {servicio?.tipoDesplazamiento === "Domicilio" ? (
                  <div className="mt-3 pt-3" style={{ borderTop: "1px solid var(--color-border)" }}>
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <div
                        className="d-flex align-items-center justify-content-center flex-shrink-0"
                        style={{
                          width: 30,
                          height: 30,
                          borderRadius: 10,
                          background: "rgba(var(--azul-logo-claro-rgb), 0.10)",
                          color: "var(--azul-logo-claro)",
                          fontSize: 14,
                        }}
                      >
                        <i className="bi bi-geo-alt-fill"></i>
                      </div>
                      <div>
                        <div className="fw-bold" style={{ fontSize: 15, color: "var(--color-text-primary)" }}>
                          Ubicación del domicilio
                        </div>
                        <div className="text-body-secondary" style={{ fontSize: 12 }}>
                          Revisa los datos donde recibirás el servicio.
                        </div>
                      </div>
                    </div>

                    <div className="row g-2">
                      <div className="col-6 col-md-3">
                        <div className="p-2 h-100 rounded-3" style={{ background: "var(--color-track-bg)" }}>
                          <div className="text-body-secondary text-uppercase fw-semibold mb-1" style={{ fontSize: 10, letterSpacing: ".04em" }}>País</div>
                          <div className="fw-bold" style={{ fontSize: 14 }}>{reserva?.paisUsuario || servicio?.pais || "NA"}</div>
                        </div>
                      </div>

                      <div className="col-6 col-md-3">
                        <div className="p-2 h-100 rounded-3" style={{ background: "var(--color-track-bg)" }}>
                          <div className="text-body-secondary text-uppercase fw-semibold mb-1" style={{ fontSize: 10, letterSpacing: ".04em" }}>Zona</div>
                          <div className="fw-bold" style={{ fontSize: 14 }}>{reserva?.zonaUsuario || servicio?.zona || "NA"}</div>
                        </div>
                      </div>

                      <div className="col-6 col-md-3">
                        <div className="p-2 h-100 rounded-3" style={{ background: "var(--color-track-bg)" }}>
                          <div className="text-body-secondary text-uppercase fw-semibold mb-1" style={{ fontSize: 10, letterSpacing: ".04em" }}>Ciudad</div>
                          <div className="fw-bold" style={{ fontSize: 14 }}>{reserva?.ciudadUsuario || servicio?.ciudad || "NA"}</div>
                        </div>
                      </div>

                      <div className="col-6 col-md-3">
                        <div className="p-2 h-100 rounded-3" style={{ background: "var(--color-track-bg)" }}>
                          <div className="text-body-secondary text-uppercase fw-semibold mb-1" style={{ fontSize: 10, letterSpacing: ".04em" }}>Subzona</div>
                          <div className="fw-bold" style={{ fontSize: 14 }}>{reserva?.subzonaUsuario || "NA"}</div>
                        </div>
                      </div>

                      <div className="col-12 col-md-7">
                        <div className="p-2 h-100 rounded-3" style={{ background: "var(--color-track-bg)" }}>
                          <div className="text-body-secondary text-uppercase fw-semibold mb-1" style={{ fontSize: 10, letterSpacing: ".04em" }}>Dirección</div>
                          <div className="fw-bold" style={{ fontSize: 15, lineHeight: 1.25 }}>{reserva?.direccionUsuario || "NA"}</div>
                        </div>
                      </div>

                      <div className="col-12 col-md-5">
                        <div className="p-2 h-100 rounded-3" style={{ background: "var(--color-track-bg)" }}>
                          <div className="text-body-secondary text-uppercase fw-semibold mb-1" style={{ fontSize: 10, letterSpacing: ".04em" }}>Referencia</div>
                          <div className="fw-bold" style={{ fontSize: 14, lineHeight: 1.25 }}>{reserva?.referenciaUsuario || "NA"}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* ZONA HORARIA */}
                <div className="mt-3 pt-3 d-flex flex-wrap align-items-center gap-2" style={{ borderTop: "1px solid var(--color-border)" }} >
                    <span className="badge rounded-pill text-bg-light border" style={{ padding: "8px 12px", fontWeight: 600 }}>
                        <i className="bi bi-globe-americas me-2"></i>
                        Zona horaria: {zonaHorariaReserva}
                    </span>
                </div>
            </div>


            {/* INFORMACIÓN DEL SERVICIO */}
            <ServicioPagoReserva  servicio={servicio} reserva={reserva} />
          </>
        )}
      </div>
    </div>
  );
}

export default ResumenReserva;